import { FunctionalComponent, h } from '@stencil/core';

/**
 * FavoriteIcon is a functional component that renders a favorite icon.
 *
 * @param {object} props - The properties passed to the component.
 * @param {string} props.className - The class name to apply to the SVG element.
 */
export const FavoriteIcon: FunctionalComponent<{className?: string}> = ({ className }: { className: string; }) =>
    <svg class={{ 'icon-favorite': true, [className]: !!className }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5
     2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
    </svg>
